import {
  Box,
  InputAdornment,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import UploadCV from "../Upload/upload";
import { useCallback } from "react";

const FormInput = ({
  label,
  placeholder,
  startIcon,
  value,
  onChange,
  error,
}) => (
  <TextFieldStyles
    fullWidth
    placeholder={placeholder}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Box component="img" src={startIcon} className="w-5 h-5" />
        </InputAdornment>
      ),
    }}
    value={value}
    onChange={onChange}
    error={!!error}
    helperText={error}
  />
);

const CoverLetterInput = ({ value, onChange }) => (
  <Box mt={4}>
    <Typography fontSize={18} fontWeight={600} color="#033F6A" gutterBottom>
      Thư giới thiệu:
    </Typography>
    <TextField
      multiline
      maxRows={4}
      rows={4}
      placeholder="Viết giới thiệu ngắn gọn về bản thân (điểm mạnh, điểm yếu) và nêu rõ mong muốn, lý do bạn muốn tuyển dụng vị trí này."
      fullWidth
      value={value}
      onChange={onChange}
    />
    <Box sx={{ textAlign: "end" }}>
      <Typography variant="caption">Không quá 2000 kí tự</Typography>
    </Box>
  </Box>
);

export default function RecruitmentApplyForm({
  formData,
  handleUpdateFormData,
  selectedFile,
  handleDrop,
  errors,
  setErrors,
}) {
  const handleChangeData = useCallback(
    (field) => (event) => {
      const value = event.target.value;
      handleUpdateFormData(field, value);
      if (value) {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: null }));
      }
    },
    [handleUpdateFormData, setErrors]
  );

  return (
    <Box sx={{ py: "24px" }}>
      <Box pb={2}>
        <Typography color="#033F6A" mb={0.8}>
          Vui lòng nhập đầy đủ thông tin chi tiết
        </Typography>
        <Typography color="#FF3033">Thông tin bắt buộc (*)</Typography>
      </Box>
      <Box
        sx={{
          px: { xs: 0, sm: 3 },
          py: { xs: 2, sm: 3 },
          border: { xs: "none", sm: "1px dashed #1C9BDB" },
          borderRadius: 1,
        }}
      >
        <FormInput
          label="Họ và tên"
          placeholder="Họ và tên của bạn"
          startIcon="/assets/icons/ic_user_linear.svg"
          value={formData.fullname}
          onChange={handleChangeData("fullname")}
          error={errors.fullname}
        />
        <Box
          mt={2}
          gap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
          }}
        >
          <FormInput
            label="Email"
            placeholder="Email của bạn"
            startIcon="/assets/icons/ic_sms_linear.svg"
            value={formData.email}
            error={errors.email}
            onChange={handleChangeData("email")}
          />
          <FormInput
            label="Số điện thoại"
            placeholder="Số điện thoại của bạn"
            startIcon="/assets/icons/ic_call_linear.svg"
            value={formData.phoneNumber}
            error={errors.phoneNumber}
            onChange={handleChangeData("phoneNumber")}
          />
          <FormInput
            label="Ngày sinh"
            placeholder="Ngày sinh của bạn (dd/MM/yyyy)"
            startIcon="/assets/icons/ic_calendar.svg"
            value={formData.dateOfBirth}
            error={errors.dateOfBirth}
            onChange={handleChangeData("dateOfBirth")}
          />
          <FormInput
            label="Địa chỉ"
            placeholder="Địa chỉ của bạn"
            startIcon="/assets/icons/ic_location_linear.svg"
            value={formData.address}
            error={errors.address}
            onChange={handleChangeData("address")}
          />
        </Box>
        <Box mt={3}>
          <UploadCV
            name="fileCV"
            accept={{ "application/pdf": [] }}
            fileName={selectedFile?.name}
            file={selectedFile}
            onDrop={handleDrop}
          />
          {errors.fileCV && (
            <Box textAlign="center">
              <Typography variant="caption" color="error">
                {errors.fileCV}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <CoverLetterInput
        value={formData.coverLetter}
        onChange={(event) =>
          handleUpdateFormData("coverLetter", event.target.value)
        }
      />
    </Box>
  );
}

const TextFieldStyles = styled(TextField)({
  "& .MuiInputBase-input": {
    padding: "14px",
    WebkitTextFillColor: "black",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    borderRadius: "8px",
  },
});
